import React, {Component, useEffect, useState} from 'react';
import withProrodinkiService from "../../components/hoc/with-prorodinki-service";
import {withRouter} from "react-router-dom"
import VerificationImageList from "./VerificationImageList";
import {removeCurrentPageEntries} from "./VerificationUtils";

const VerificationListController = (props) =>{

    let all = 'Все'
    const [forceReload, setForceReload] = useState(false)

    const [selectedDiag, setSelectedDiag] = React.useState(-1);


    const [responseObject, setResponseObject] = useState( {
        isLoading: true,
        error:false,
        errorMessage:null,
        data: [],
    })


    useEffect(  () => {
            async function fetchData() {
                setResponseObject({...responseObject,...{data:[],isLoading:true}})
                let response = await props.prorodinkiService.getVerificationCaseIdList()
                if (response.hasError) {
                    setResponseObject({
                        isLoading: false,
                        data: [],
                        error: true,
                        errorMessage: response.error.message,
                    })
                } else {
                    setResponseObject({
                        isLoading: false,
                        data: response.data, //response.data,
                        error: false,
                        errorMessage: null,
                    })
                    // console.log('verificationImageList',response.data)
                }
            }
            fetchData()
        },
        [forceReload]
    )


    const setDiagnoseSeries = async (caseIds, diagnosis) => {
        //console.log("setDiagnoseSeries caseIds",caseIds)
        //console.log("setDiagnoseSeries diagnosis",diagnosis)
        setResponseObject({...responseObject,...{data:[],isLoading:true}})
        await props.prorodinkiService.putDiagnoseSeries(caseIds, diagnosis);
        setForceReload(!forceReload)
    }
    return ( !!responseObject && !!(responseObject.data) && responseObject.data.length>0?
            <VerificationImageList
                imageIds={responseObject.data}
                setDiagnose={setDiagnoseSeries}
                prorodinkiService={props.prorodinkiService}
                diagnosis = {selectedDiag}
                setDiagnosis ={setSelectedDiag}
            />: null
    )


}

export default withRouter(withProrodinkiService(VerificationListController))

